import styled from 'styled-components';

export const Sidebar = styled.div`
    position: fixed;
    z-index: 999;
    background-color: #444;
    top: 0;
    bottom: 0;
    left: -300px;
    transition: all .4s ease 0s;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    padding-top: 30px;

    &.opened {
        left: 0;
    }
`;

export const TopContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-items: stretch;
    padding: 0 0 0 20px;
`;

export const Title = styled.div`
    color: #fff;
    font-size: 20px;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
    border-bottom: 1px solid #555;
`;

export const EmptySpace = styled.div`
    flex: 1;
`;
export const SidebarBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0, 0.7);
    z-index: 998;
    bottom: 100%;
    opacity: 0;
    transition: bottom 0s linear .4s, opacity .4s ease 0s;

    &.opened {
        bottom: 0;
        opacity: 1;
        transition: bottom 0s linear 0s, opacity .4s ease 0s;
    }
`;

export const SidebarButton = styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 4;
    background-color: #000;
    width: 30px;
    height: 30px;
    font-size: 14px;
    color: #ccc;
    border: 1px solid #ccc;
    border-radius: 15px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &:hover {
        color: #000;
        background-color: #ccc;
    }

    &:before {
        content: "\\F035C";
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

export const ButtonGroupTop = styled.div`
    padding: 20px;
`;

export const TableDetail = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

export const ButtonGroupBottom = styled.div`
    padding: 20px;
`;

export const Section = styled.div`
    color: #aaa;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 5px;
`;

export const Message = styled.div`
    color: #fff;
    font-size: 16px;
    margin: 30px 0 20px;
`;

export const Label = styled.div`
    color: #fff;
    font-size: 14px;
    margin-bottom: 15px;
`;

export const InputField = styled.input`
    border: 1px solid #555;
    background-color: #333;
    padding: 0 5px;
    color: #fff;
    height: 40px;
    width: 100%;
    margin: 5px 0 10px;

    &:focus{
        outline: none;
    }
`;

export const Error = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    height: 30px;
    background-color: #500;
    border: 1px solid #900;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const FieldsRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    & > :not(:last-child) {
        margin-right: 10px;
    }
`;


export const SelectField = styled.select`
    border: 1px solid #555;
    background-color: #333;
    padding: 0 5px;
    color: #fff;
    height: 40px;
    width: 100%;
    margin: 5px 0 10px;
    
    &:focus{
        outline: none;
    }
`;

export const ThumbRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    margin-bottom: 20px;
`;

export const Thumbnail = styled.div`
    height: 70px;
    width: 70px;
    background-color: #444;
    border: 1px solid #999;
    margin-right: 10px;
    position: relative;
`;

export const Tag = styled.div`
    height: 33px;
    min-height: 33px;
    font-size: 15px;
    padding: 0 7px;
    color: #fff;
    box-sizing: border-box;
    border: 3px solid ${p => p.color ?? '#fff'};
    border-radius: 15px;
    transition: all .3s ease 0s;
    margin: 0 5px 5px 0;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const TagGroup = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 10px;
`;

export const NoValue = styled.div`
    font-size: 14px;
    margin-bottom: 10px;
    color: #999;
`;
